import Vue from "vue";

Vue.component("notification-download-document", {
	props: ["notificationId"],
	data() {
		return {
			items: []
		};
	},
	methods: {
		GetDownloadLinks: function(notificationId) {
			this.isDownloading = true;
			this.$services.AzureSearches.getDownloadLinks({
				notificationId: this.notificationId
			})
				.then((data) => {
					this.items = data
				});
		},
	},
	mounted: function () {
		this.GetDownloadLinks();
	},
	template: `
	  <div style="position: absolute;right: 0px;top: 0px;">
		<a style="padding-right: 7px;" v-for="(item, index) in items" v-bind:key="index" :href="item.urlLink">
		  <i class="fas fa-file-word"></i><span style="padding-left: 3px">{{ item.displayName }}</span>
		</a>		  
	  </div>
	`
});